import React from 'react'

export default function(state, payload) {
  let usrdt = payload.user ? payload.user : undefined
  let usrid = payload.user ? payload.user._id : undefined
  let token = payload.token ? payload.token : undefined
  
  localStorage.setItem('session-token', token);
  localStorage.setItem('session-usrid', usrid);

  return {
  	...state, 
  	data: usrdt, 
  	logged: true, 
  	logging: false,
    success: true
  };
}